import { ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsPositive, IsString, Max, Min } from 'class-validator';

export class ListInputModel {
  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  @IsPositive()
  @Min(1)
  @Type(() => Number)
  public page?: number;

  @ApiPropertyOptional()
  @IsOptional()
  @IsString()
  public search?: string;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  @IsPositive()
  @Max(1000)
  @Type(() => Number)
  public size?: number;

  @ApiPropertyOptional()
  @IsOptional()
  @IsString()
  public sort?: string;
}
